export enum UserType {
    SUPER_ADMIN = '12'
    , SUPPORT = '13'
}


// WEBPACK FOOTER //
// ./src/enums/usertype.enum.ts